export default __webpack_public_path__ + "static/media/hostel1.89c61657.png";